import { createFileRoute } from '@tanstack/react-router'
import { InternshipHubPage } from '@/pages/internship-hub/ui/InternshipHubPage'

export const Route = createFileRoute('/internship-hub')({
  component: InternshipHubPage,
})
